var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeBottomLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 310,
    viewBox: "0 0 346 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1841_7592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 346,
    height: 310
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 346,
    height: 310,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1841_7592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.065 370.864L276.162 148.853C270.142 132.124 251.71 123.449 234.982 129.47L137.863 164.423L86.4468 21.5638C80.4261 4.8352 61.9949 -3.8402 45.2663 2.18052L-176.744 82.0832C-193.473 88.1039 -202.149 106.535 -196.128 123.264L-116.225 345.275C-110.204 362.003 -91.7732 370.679 -75.0446 364.658L22.0745 329.704L73.4903 472.564C79.511 489.292 97.9422 497.968 114.671 491.947L336.682 412.044C353.41 406.024 362.086 387.592 356.065 370.864Z",
    fill: "#FFF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.775 180.541C154.255 180.728 153.682 180.458 153.495 179.939L102.079 37.0792C96.2455 20.8703 78.3872 12.4645 62.1782 18.2982L-159.833 98.2009C-176.042 104.035 -184.447 121.893 -178.614 138.102L-98.7109 360.113C-92.8772 376.322 -75.0189 384.727 -58.81 378.894L38.3091 343.94C38.8288 343.753 39.4016 344.023 39.5887 344.542L91.0045 487.402C96.8382 503.611 114.696 512.017 130.905 506.183L352.916 426.28C369.125 420.447 377.531 402.588 371.697 386.379L291.795 164.368C285.961 148.159 268.103 139.754 251.894 145.587L154.775 180.541ZM292.735 164.03L372.638 386.041C378.659 402.769 369.984 421.2 353.255 427.221L131.244 507.124C114.515 513.145 96.0843 504.469 90.0636 487.741L38.6478 344.881L-58.4713 379.835C-75.2 385.855 -93.6311 377.18 -99.6518 360.451L-179.555 138.441C-185.575 121.712 -176.9 103.281 -160.171 97.26L61.8395 17.3573C78.5682 11.3366 96.9994 20.012 103.02 36.7406L154.436 179.6L251.555 144.646C268.284 138.626 286.715 147.301 292.735 164.03Z",
    fill: "#FF8FA9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeBottomLeft);
export default __webpack_public_path__ + "static/media/shape-bottom-left.52006d627c95db9853a03e9fe1920aa9.svg";
export { ForwardRef as ReactComponent };